import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import 'swiper/css';
import 'swiper/css/navigation';
import type { Swiper as SwiperType } from 'swiper/types';

interface ImageSliderProps {
    images: string[];
    color: string;
}

const ImageSlider: React.FC<ImageSliderProps> = ({ images, color }) => {
    //   const [activeIndex, setActiveIndex] = useState(0);
    const [swiperInstance, setSwiperInstance] = useState<SwiperType | null>(null);

    // Сохраняем экземпляр Swiper
    const onSwiper = (swiper: SwiperType) => {
        setSwiperInstance(swiper);
    };

    // Обновляем активный слайд
    useEffect(() => {
        if (swiperInstance) {
            const handleSlideChange = () => {
                // setActiveIndex(swiperInstance.activeIndex);
            };
            swiperInstance.on('slideChange', handleSlideChange);
            return () => {
                swiperInstance.off('slideChange', handleSlideChange);
            };
        }
    }, [swiperInstance]);

    return (
        <div className="w-full mx-auto">
            {/* Слайдер */}
            <Swiper
                onSwiper={onSwiper}
                modules={[Navigation, Autoplay]}
                loop={true}
                speed={1000}
                spaceBetween={50}
                slidesPerView={1}
                className="w-full h-[100%] aspect-[6/4] lg:aspect-[16/11]"
            >
                {images.map((src, index) => (
                    <SwiperSlide key={index}>
                        <div className="relative w-full h-full overflow-hidden rounded-md lg:rounded-lg shadow-sm lg:shadow-md">
                            <img
                                key={index}
                                loading="lazy"
                                src={src}
                                alt={`${index + 1}`}
                                className="w-full h-full object-contain rounded-md lg:rounded-lg"
                            />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* Кнопки под слайдером */}
            <div className="flex justify-around mt-2 lg:mt-5">
                <button
                    onClick={() => swiperInstance?.slidePrev()}
                    disabled={!swiperInstance}
                >
                    <ArrowBackIosRoundedIcon
                        sx={{
                            fontSize: {
                                xs: '1.5rem',
                                lg: '2.5rem',
                                xl: '3.0rem',
                            }, color: `${color}`
                        }}
                    />
                </button>
                <button
                    onClick={() => swiperInstance?.slideNext()}
                    disabled={!swiperInstance}
                >
                    <ArrowBackIosRoundedIcon
                        sx={{
                            fontSize: {
                                xs: '1.5rem',
                                lg: '2.5rem',
                                xl: '3.0rem',
                            }, 
                            color: `${color}`,
                            transform: 'rotate(180deg)'
                        }}
                    />
                </button>
            </div>
        </div>
    );
};

export default ImageSlider;